import { render, staticRenderFns } from "./modale.vue?vue&type=template&id=646bb70e&scoped=true"
import script from "./modale.vue?vue&type=script&lang=js"
export * from "./modale.vue?vue&type=script&lang=js"
import style0 from "./modale.vue?vue&type=style&index=0&id=646bb70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646bb70e",
  null
  
)

export default component.exports